<template>
  <div id="footer" class="hidden-sm-and-up">
    <router-link to="/" class="footer_item" :class="active == 0? 'active' :''">
      <div class="icon_wrap">
         <img class="fimg" v-show="active == 0" src="../../assets/images/footer_nav/01.png" alt="">
         <img class="fimg" v-show="active != 0" src="../../assets/images/footer_nav/02.png" alt="">
      </div>
      <p class="footer_info">Inicio</p>
    </router-link>

    <router-link to="/share" class="footer_item" :class="active == 1? 'active' :''">
      <div class="icon_wrap">
        <img class="fimg" v-show="active == 1" src="../../assets/images/footer_nav/03.png" alt="">
         <img class="fimg" v-show="active != 1" src="../../assets/images/footer_nav/04.png" alt="">
      </div>
      <p class="footer_info">Promoção</p>
    </router-link>

    <router-link to="/recharge" class="footer_item" :class="active == 2? 'active' :''">
      <div class="icon_wrap">
        <img class="fimg" v-show="active == 2" src="../../assets/images/footer_nav/05.png" alt="">
         <img class="fimg" v-show="active != 2" src="../../assets/images/footer_nav/06.png" alt="">
      </div>
      <p class="footer_info">Fundos</p>
    </router-link>

    <router-link to="/support" class="footer_item" :class="active == 3? 'active' :''">
      <div class="icon_wrap">
        <img class="fimg" v-show="active == 3" src="../../assets/images/footer_nav/07.png" alt="">
         <img class="fimg" v-show="active != 3" src="../../assets/images/footer_nav/08.png" alt="">
      </div>
      <p class="footer_info">Suporte</p>
    </router-link>

    <router-link to="/person" class="footer_item" :class="active == 4? 'active' :''">
      <div class="icon_wrap">
        <img class="fimg" v-show="active == 4" src="../../assets/images/footer_nav/09.png" alt="">
         <img class="fimg" v-show="active != 4" src="../../assets/images/footer_nav/10.png" alt="">
      </div>
      <p class="footer_info">Perfil</p>
    </router-link>
  </div>
</template>
<script>
export default {


  data() {
    return {
        active:0,
    };
  },
  created() {
    // console.log(this.active)
      this.$bus.$on('send2ftnav',(idx)=>{
          this.active = idx;
      })
  },

};
</script>
<style lang="less" scoped>
#footer {
  position: fixed;
  height: 1.6rem;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background-color: #4a0617;
  border-top:0.02rem solid #b62641;
  color: #e5d3bf;
}
.fimg{
  width: 1.2rem;
}
.footer_item {
  display: flex;
  width: 25%;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 0rem 0;
}

.icon_wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.ft_icon {
  font-size: 0.667rem;
  color: #f9c0cf;
}

.footer_info {
  color: #ece5e6;
  margin-top: -0.1rem;
}
.active .ft_icon{
  font-size: 0.7rem;
  color: #f53752;
}
.active .footer_info{
  color: #ece5e6;
}
</style>